import type { Trade } from "@ct/shared-types";

interface Props {
  trades: Trade[];
  emptyMessage?: string;
}

const fmtNum = (n: number | undefined, digits = 4): string =>
  n == null || Number.isNaN(n) ? "—" : n.toFixed(digits);

const fmtTime = (ms: number | undefined): string =>
  ms ? new Date(ms).toISOString().slice(11, 19) : "—";

const pnlClass = (n: number | undefined): string => {
  if (n == null) return "text-zinc-400";
  if (n > 0) return "text-accent";
  if (n < 0) return "text-bear";
  return "text-zinc-400";
};

export function TradesTable({ trades, emptyMessage }: Props) {
  if (trades.length === 0) {
    return (
      <div className="p-4 text-xs text-zinc-500">
        {emptyMessage ?? "No trades."}
      </div>
    );
  }
  return (
    <table className="w-full text-xs">
      <thead className="sticky top-0 bg-zinc-950 text-zinc-500">
        <tr className="text-left">
          <th className="px-3 py-2">Strategy</th>
          <th className="px-3 py-2">Symbol</th>
          <th className="px-3 py-2">Side</th>
          <th className="px-3 py-2">Qty</th>
          <th className="px-3 py-2">Entry</th>
          <th className="px-3 py-2">Exit</th>
          <th className="px-3 py-2">PnL</th>
          <th className="px-3 py-2">PnL%</th>
          <th className="px-3 py-2">Status</th>
          <th className="px-3 py-2">Opened</th>
        </tr>
      </thead>
      <tbody>
        {trades.map((t) => (
          <tr key={t.id} className="border-t border-zinc-900 hover:bg-zinc-900/40">
            <td className="px-3 py-2 font-mono text-zinc-300">{t.strategyId}</td>
            <td className="px-3 py-2 font-mono text-zinc-200">
              {t.exchange} · {t.symbol}
            </td>
            <td className="px-3 py-2">
              <span className="se-pill se-pill-buy">BUY</span>
            </td>
            <td className="px-3 py-2 font-mono">{fmtNum(t.quantity, 6)}</td>
            <td className="px-3 py-2 font-mono">{fmtNum(t.entryPrice)}</td>
            <td className="px-3 py-2 font-mono">{fmtNum(t.exitPrice)}</td>
            <td className={`px-3 py-2 font-mono ${pnlClass(t.realizedPnl)}`}>
              {fmtNum(t.realizedPnl, 2)}
            </td>
            <td className={`px-3 py-2 font-mono ${pnlClass(t.realizedPnlPct)}`}>
              {fmtNum(t.realizedPnlPct, 2)}
            </td>
            <td className="px-3 py-2">{t.status}</td>
            <td className="px-3 py-2 font-mono text-zinc-500">
              {fmtTime(t.openedAt)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
